import MatchEvent from 'interfaces/matchEvent';
import { Match } from 'interfaces/match';
import { MatchEventStatus } from '../../../enums/matchEventStatus';

/**
 * add matchEvent status and previousValue when it loads from server
 * @param {Match} match
 * @return {Match}
 */
export default function (match: Match): Match {
  if (match.matchEvents) {
    match.matchEvents = match.matchEvents.map((matchEvent: MatchEvent) => {
      const { ...rest } = matchEvent;
      if (!matchEvent.internal) {
        matchEvent.internal = {};
      }
      matchEvent.internal.status = MatchEventStatus.PUBLISHED;
      matchEvent.internal.previousValue = rest;
      return matchEvent;
    });
  }
  return match;
}
